

import Roadmap from "../comp/roadmap/Roadmap";


const Mint = () => {
    return (
        <div>

            <Roadmap></Roadmap>
        </div>
    )
}

export default Roadmap;